export function formatPrice(languageCode, price) {
  return new Intl.NumberFormat(languageCode, {
    style: "currency",
    currency: "EUR",
  })
    .format(price)
    .replace("€", "€ ")
    .replace(" € ", " €");
}
